import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import journal2image2 from '../../documents/journal2image2.JPG'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Journal2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            journal2Objective:"Novel method for estimation of percentage mass loss of structural elements due to corrosion",
            journal2Key:['Providing useful insights for structural audit and serviceability', '17 lab controlled samples from 2 different methods of corrosion', '1 rational, reliable, dimensionally stable MDA formulation', 'Validating MDA model with actual lab AE results', '4 Acoustic Emission Techniques features',
            'Comparison with other empirical models'],
            journal2Value:['Decision Making', 'Applied Research', 'Accountability'],  
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader><EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Mathematical Models for estimation of percentage mass loss using optimum Acoustic Emission parameters</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Mentor :- Dr. Shilpa Patil   &emsp; &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; March 2021- Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiText><b>Research Objectives</b><br/>
                        {this.state.journal2Objective}<EuiSpacer/>
                        <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.journal2Key && this.state.journal2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.journal2Value && this.state.journal2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                        </EuiFlexItem><div>
                <EuiFlexItem ><br/><EuiText textAlign='left' ><EuiImage style={{width: '12vw',height: '35vw'}} src={journal2image2} /></EuiText></EuiFlexItem></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Journal2 }